import { useMutation, useQueryClient } from '@tanstack/react-query';
import { fetch } from '../fetch';
import { AnalysisDtoType, schemas } from '@convergence/client';

export const useLaunchAnalysisMutation = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationKey: ['launchAnalysis'],
    mutationFn: async (args: { analysisId: string; analysisSlug: string }) => {
      return fetch(
        `/analysis/${args.analysisId}`,
        { method: 'post' },
        schemas.CreateAndLaunchAnalysisResponseDto
      );
    },
    // onMutate: async (args) => {
    //   const queryKey = ['analysis', args.analysisSlug];
    //   await queryClient.cancelQueries({
    //     queryKey
    //   });
    //   const previousData = queryClient.getQueryData(queryKey);
    //
    //   queryClient.setQueryData<AnalysisDtoType>(queryKey, (oldData) => {
    //     if (!oldData) return oldData;
    //     return { ...oldData, status: 'PENDING' };
    //   });
    //
    //   return { previousData };
    // },
    // onError: (_, data, context) => {
    //   queryClient.setQueryData(
    //     ['analysis', data.analysisSlug],
    //     context?.previousData
    //   );
    // },
    // // Always refetch after error or success:
    // onSettled: (data) => {
    //   queryClient.invalidateQueries({
    //     queryKey: ['analysis', data?.analysisSlug]
    //   });
    // },
    retry: false
  });

  return mutation;
};
